module.exports = __webpack_public_path__ + "static/thumb-bela-vrtnica-00595dffabc35faf6c9e756b48a98380.jpg";